import {servicioRestfulCompleto, servidor} from "../../Configuracion";
import ClienteRestful from "../../../framework2/ej2/network/ClienteRestful";
import {estadoChangeClinica} from "../estado/actions";


export const DM_CLINICA_LOADED = 'DM_CLINICA_LOADED';
export const DM_CLINICAS_LOADED = 'DM_CLINICAS_LOADED';
export const DM_DOCTORES_LOADED = 'DM_DOCTORES_LOADED';

export const DM_TRATAMIENTOTIPOS_LOADED = 'DM_TRATAMIENTOTIPOS_LOADED';

export const clinicaLoaded = (newClinica) => {
 return {
        type: DM_CLINICA_LOADED,
        clinica: newClinica,
    }
}
export const clinicasLoaded = (newClinicas) => {
    return {
        type: DM_CLINICAS_LOADED,
        clinicas: newClinicas,
    }
}
export const doctoresLoaded = (newDoctores) => {
    return {
        type: DM_DOCTORES_LOADED,
        doctores: newDoctores,
    }
}

export const tratamientotiposLoaded = (newTratamientotipos) => {
    return {
        type: DM_TRATAMIENTOTIPOS_LOADED,
        tratamientotipos: newTratamientotipos,
    }
}

export const loadDatosMaestros= (clinicaCodigo) => {
    console.log("LOAD DATOS MAESTROS");
    console.log("clinicaCodigo: ", clinicaCodigo);
    return (dispatch) => {
        let url = servidor + "minimo/ej2/datosmaestros/" + clinicaCodigo;
        new ClienteRestful().setUrl(url)
            .doGet(response => {
                let datosmaestros = response
                console.log("++++ datosmaestros: ", datosmaestros);
                dispatch(clinicaLoaded(datosmaestros.clinica));
                dispatch(clinicasLoaded(datosmaestros.clinicas));
                dispatch(doctoresLoaded(datosmaestros.doctores));
                dispatch(estadoChangeClinica(datosmaestros.clinica));
                dispatch(tratamientotiposLoaded(datosmaestros.tratamientotipos));

            });
    }
}



